(ns dashboard.views.workbook-workspace.components.browser
  (:require [clojure.set :as set]
            [re-frame.core :as rf]
            [dashboard.subs :as common-subs]
            [dashboard.ui :as ui]
            [dashboard.views.workbook-workspace.events :as events]
            [dashboard.views.workbook-workspace.subs :as subs]
            [dashboard.views.workbook-workspace.components.common :as components]
            [dashboard.views.workbook-workspace.components.modal-save-extraction-results :refer [modal-save-extraction-results]]
            [dashboard.views.workbook-workspace.components.grid :as grid]))

(defn panel-top-bar-classes [{:keys [size is-visible?]}]
  (if is-visible?
    [(str "is-" size)
     ;"has-background-light"
     "is-flex"
     "is-flex-direction-column"
     "is-justify-content-space-between"]
    ["is-narrow" "has-background-secondary"]))

(defn on-change-depth [{:keys [new-depth original-depth row-index]}]
  (if (= new-depth original-depth)
    (rf/dispatch [::events/workbook-workspace.active-sheet.value-exception.clear
                  {:row-index row-index
                   :name      :depth}])
    (rf/dispatch [::events/workbook-workspace.active-sheet.value-exception.set
                  {:row-index row-index
                   :name      :depth
                   :value     new-depth}])))

(defn result-list-item [{:keys [content response additional-information analysis
                                depth num
                                path row-index
                                all-results]
                         :as result}]
  [:div.panel-block.is-flex.is-flex-direction-column.is-align-items-stretch.p-0
   {:style {:cursor "auto"}
    :class [(str "ml-" (dec (:depth result)))]}
   [:div.pt-1.pb-3
    [:div.level.level-items.mb-0.has-background-secondary
     [:div.level-item.level-left
      [:button.button.is-small.is-text.is-rounded
       {:on-click #(rf/dispatch [::events/workbook-workspace.grid.set-selected-cells
                                 {:row-index row-index
                                  :columns (select-keys result (keys grid/column-options))}])
        :title "Select question cells"}

       "show"]]
     [:div.level-item.level-right
      [:button.button.is-small.is-text.is-rounded
       {:on-click #(rf/dispatch [::events/workbook-workspace.active-sheet.remove-question-row row-index])
        :title "Remove question row"}
       "remove selection"]]]
    [:div.mx-3.pt-3

     [:div.columns.p-0.m-0
      [:div.column.is-half.p-1
       [:span.has-text-weight-bold (str (:num grid/column-options) ":")]]
      [:div.column.is-half.p-1
       (:content num)]]

     [:div.block.px-1.m-0
      [:span.has-text-weight-bold (str (:content grid/column-options) ":")]
      [:br]
      [:div.notification.has-background-white-bis
       (:content content)]]

     [:div.columns.p-0.m-0
      [:div.column.is-half.p-1
       [:span.has-text-weight-bold
        {:title "The \"depth\" relative to the parent rows. Based on this value, question can have a parent."}
        "Question depth:"]]
      [:div.column.is-half.p-1
       [:div.level.level-items.m-0
        [:div.level-item.level-left
         (:content depth)]
        [:div.level-item.level-right
         [:div.buttons
          [:button.button.is-small.is-rounded.is-secondary
           {:on-click #(on-change-depth {:row-index (:row-index result)
                                         :original-depth (:original depth)
                                         :new-depth (dec (:content depth))})
            :title "Move this question up in the question hierarchy"
            :disabled (= 1 (:content depth))}
           "-"]
          [:button.button.is-small.is-rounded.is-secondary
           {:on-click #(on-change-depth {:row-index (:row-index result)
                                         :original-depth (:original depth)
                                         :new-depth (inc (:content depth))})
            :title "Move this question down in question hierarchy to make it a follow-up question for the previous question"
            :disabled (nil? (:preceding result))}
           "+"]]]]]]

     (cond
       (and path
            (= 1 (count path)))
       [:p.has-text-danger "Question parent is missing!"]

       (> (count path) 2)
       [:div.columns.p-0.m-0
        [:div.column.is-half.p-1
         [:span.has-text-weight-bold "Parent question:"]]
        [:div.column.is-half.p-1
         (let [parent-path (subvec path 0 (dec (count path)))
               parent-result (first (filter (fn [{result-path :path}]
                                              (= result-path parent-path))
                                            all-results))]
           (-> parent-result :content :content))]])

     (when response
       [:div.block.px-1.m-0
        [:span.has-text-weight-bold (str (:response grid/column-options) ":")]
        [:br]
        [:div.notification.has-background-white-bis
         (:content response)]])

     (when additional-information
       [:div.block.px-1.m-0
        [:span.has-text-weight-bold (str (:additional-information grid/column-options) ":")]
        [:br]
        [:div.notification.has-background-white-bis
         (:content additional-information)]])

     (when analysis
       [:div.block.px-1.m-0
        [:span.has-text-weight-bold (str (:analysis grid/column-options) ":")]
        [:br]
        [:div.notification.has-background-white-bis
         (:content analysis)]])]]])

(defn Results [_]
  (let [results @(rf/subscribe [::subs/workbook-workspace.results])]
    [:div
     [:div.is-flex.is-flex-direction-column.is-flex-grow-1
      {:style {:overflow "hidden"}}
      [:div
       {:style {:overflow-y "auto"}}
       (if (empty? results)
         [:div.has-text-centered.has-text-weight-bold.p3 "No Results To Show"]
         (map (fn [result-item]
                [result-list-item (merge {:key (:row-index result-item)
                                          :all-results results}
                                         result-item)])
              results))]]]))

(defn browser [{:keys [panel-max-height on-save]}]
  (let [{:keys [path
                workbooks
                size
                is-visible?
                loading-workbooks?]} @(rf/subscribe [::subs/workbook-workspace.browser])
        sizer-fn (fn [f]
                   (fn []
                     (rf/dispatch [::events/workbook-workspace.panel.set-size
                                   :browser
                                   (f size)])))

        toggle-visibility #(rf/dispatch [::events/workbook-workspace.panel.toggle-visibility
                                         :browser])]

    [:div.column.p-0 {:class (panel-top-bar-classes {:is-visible? is-visible? :size size})
                      :style {:max-height panel-max-height
                              :max-width "70vw"
                              :overflow   "hidden"}}
     [components/panel-top-bar
      [:<>
       [:div.level-item.level-left.ml-1
       (when is-visible? [:p "Browse"])]

      [:div.level-item.level-right
       (if is-visible?
         [:button {:style    {:cursor "pointer"
                            :height "1.5rem"
                            :width  "1.5rem"}
                 :class    ["has-text-centered
                             is-tertiary
                             button"]
                 :on-click toggle-visibility
                 :title    "Collapse browser"}
          "<"]
         [:span {:style {:cursor           "pointer"
                         :width            "1rem"
                         :margin      "5rem 1rem 1rem 0.5rem"}

                 :class    ["has-text-centered"]
                 :on-click toggle-visibility
                 :title    "Expand browser"}
          [:i.icon.fas.fa-bars]])]]]
     (when is-visible?
       (let [head     (last path)
             set-path (fn [path]
                        (rf/dispatch [::events/workbook-workspace.browser.set-path path]))
             loader   [:div>progress.progress.is-small.is-success
                       {:max   "100"
                        :style {:opacity 0.2}} "15%"]]
         [:div.p-1.is-flex.is-flex-direction-column.is-flex-grow-1
          {:style {:overflow "hidden"}}
          [:nav.breadcrumb.is-flex.mb-2.pb-1
           {:aria-label "breadcrumbs"
            :style      {:border-bottom "1px solid lightgrey"
                         :flex-flow     "row wrap"}}
           [:ul
            (map-indexed (fn [index {:keys [path-type]
                                     :as path-element}]
                           [:li {:on-click #(set-path (into []
                                                            (take
                                                              (inc index)
                                                              path)))
                                 :class    [(when (= path-element head)
                                              "is-active")]
                                 :style    {:white-space "normal"}
                                 :key      (str path-element)}
                            [:a {:href "#"}
                             (case path-type
                               :root (:title path-element)
                               :workbook (:filename path-element)
                               :sheet (:sheet-name path-element))]])
                         path)]]
          [:div.is-flex.is-flex-direction-column.is-flex-grow-1
           {:style {:overflow-y "auto"}}
           (case (count path)
             1 (if loading-workbooks?
                      loader
                      (map (fn [[_ {:keys [filename] questionnaire :id}]]
                             [:div.panel-block.mb-1.p-2
                              {:key      questionnaire
                               :on-click #(set-path (conj path {:path-type :workbook
                                                                :filename filename
                                                                :questionnaire questionnaire}))
                               :title    "Show sheets in workbook"
                               :style    {:border-left   "2px solid transparent"
                                          :border-bottom "1px solid lightgrey"
                                          :cursor        "pointer"
                                          :background    (when (= (first path) filename)
                                                           "pink")}}
                              filename])
                           (sort-by (fn [[_ {:keys [filename]}]]
                                      filename)
                                    workbooks)))
             2 (let [{:keys [sheets loading-sheets?]} (get workbooks (:questionnaire head))]
                     (if-not sheets
                       (if loading-sheets?
                         loader
                         [:div "no sheets"])
                       (->> sheets
                            (sort-by :name)
                            (map (fn [{sheet-name :name
                                       extracted? :questions-extracted
                                       sheet-id :sheet}]
                                   [:div.panel-block.pt-1.p-2.is-justify-content-space-between
                                    {:key      sheet-name
                                     :on-click #(set-path (conj path {:path-type :sheet
                                                                      :questionnaire (:questionnaire head)
                                                                      :sheet-name sheet-name
                                                                      :sheet-id sheet-id}))
                                     :title    "Show sheet contents"
                                     :style    {:border-left   "2px solid transparent"
                                                :border-bottom "1px solid lightgrey"
                                                :cursor        "pointer"}}
                                    [:div sheet-name]
                                    (when extracted?
                                      [:div.is-flex.is-align-items-center
                                       {:style {:border-radius "50%"
                                                :border        "1px solid green"
                                                :width         "1rem"
                                                :height        "1rem"
                                                :color         "green"}}
                                       "✓"])])))))
             ; else
             [:<>
              (let [{:keys [sheets loading-sheets?]} (get workbooks (:questionnaire head))
                    sheets (->> sheets
                                (sort-by :name)
                                (map-indexed (fn [idx sheet] (assoc sheet :index idx)))
                                vec)
                    selected-index (some
                                    (fn [sheet]
                                      (and (= (:sheet sheet)
                                              (-> path last :sheet-id))
                                           (:index sheet)))
                                    sheets)
                    handler (fn [direction e]
                              (let [{:keys [name sheet]} (get sheets (direction selected-index))]
                                (set-path (-> path
                                              butlast
                                              vec
                                              (conj  {:path-type :sheet
                                                      :questionnaire (:questionnaire head)
                                                      :sheet-name name
                                                      :sheet-id sheet})))))]
                [:div.level-left.my-0.is-flex
                 [:button.button.is-small.is-flex-grow-1
                  {:disabled (zero? selected-index)
                   :on-click (partial handler dec)}
                  "<< Previous"]
                 [:button.button.is-small.is-flex-grow-1
                 {:disabled (= selected-index (dec (count sheets)))
                  :on-click (partial handler inc)}
                  "Next >>"]])
              [Results]])]]))

     (when is-visible?
       (let [{:keys [questionnaire sheet-id]} @(rf/subscribe [::subs/workbook-workspace.grid])]
         [:div.is-flex.is-flex-wrap-wrap.is-justify-content-space-between.ml-3.mr-1
          [:div.buttons.is-flex-grow-1.mb-1
           (when (and questionnaire sheet-id)
             (let [{:keys [columns question-rows questions-extracted]} @(rf/subscribe [::subs/parsing-config questionnaire sheet-id])
                   selected-columns (set (vals columns))
                   features-enabled @(rf/subscribe [::common-subs/features-enabled])
                   required-columns (if (contains? features-enabled :structured-analysis-creation)
                                      #{:content}
                                      #{:content :response})
                   import-allowed? (and (set/subset? required-columns selected-columns)
                                        (seq question-rows))]
               [:<>
                [:button.button.is-small.is-secondary.is-flex-grow-1.is-rounded
                 {:disabled (not import-allowed?)
                  :on-click (fn [_]
                              (rf/dispatch [::events/workbook-workspace.active-sheet.configuration.save]))
                  :title (str "Save parsing configuration"
                              (when (not import-allowed?)
                                "\n\nDefine question and response columns at minimum to save workbook parsing configuration"))}
                 "Save Configuration"]
                [:button.button.is-small.is-primary.is-flex-grow-1.mr-2.is-rounded
                 {:disabled (or (not import-allowed?)
                                questions-extracted)
                  :on-click (fn [_]
                              (rf/dispatch [::ui/push-modal {:component (partial modal-save-extraction-results on-save)}]))
                  :title (if questions-extracted
                           "Questions have been imported already"
                           "Import questions from the sheet rows as questions in the questionnaire for this workbook")}
                 "Import questions"]
                ;; TODO: We could here also do parsing, after mandatory columns are selected and rows are selected.
                ;;       Would need to way to show errors same way when import button is pressed.
                (when (not import-allowed?)
                  [:span.icon.is-medium.ml-2
                   [:i {:title (str (when-not (set/subset? required-columns selected-columns)
                                      "Define question and response columns at minimum")
                                    (when-not (seq question-rows)
                                      "\n\nSelect question rows"))
                        :class "fas fa-2x fa-exclamation-triangle has-text-warning-dark"}]])]))]
          [:div.buttons.ml-0.mb-1.is-flex-grow-1.is.is-flex.is-justify-content-flex-end.mr-2
           {:class ["level-right"]}
           [components/sizer-button
            {:on-click (sizer-fn dec)
             :style    {:cursor "pointer"}} "-"]
           [components/sizer-button
            {:on-click (sizer-fn inc)
             :style    {:cursor "pointer"}} "+"]]]))]))
